import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
interface NavigationProps {
  isMobile?: boolean;
}
export const Navigation = ({
  isMobile = false
}: NavigationProps) => {
  const navItems = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'The Team',
    path: '/team'
  }, {
    name: 'Gallery',
    path: '/gallery'
  }, {
    name: 'Blog',
    path: '/blog'
  }, {
    name: 'Stories',
    path: '/success-stories'
  }, {
    name: 'Salon Spotlight',
    path: '/salon-spotlight'
  }, {
    name: 'Join the Salon',
    path: '/joinnow'
  }, {
    name: 'Host a Salon',
    path: '/host-salon'
  }, {
    name: 'Partner with Us',
    path: '/partner-with-us'
  }, {
    name: 'Join Our Team',
    path: '/join-team'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <nav data-id="element-750">
      <ul className={`flex ${isMobile ? 'flex-col space-y-4' : 'space-x-4 flex-wrap'}`} data-id="element-751">
        {navItems.map((item, index) => <li key={item.name} className="relative flex items-center" data-id="element-752">
            <Link to={item.path} className="text-secondary-dark hover:text-primary transition-colors py-1 border-b-2 border-transparent hover:border-primary" data-id="element-753">
              {item.name}
            </Link>
            {!isMobile && index < navItems.length - 1 && <span className="mx-2 h-4 border-r border-gray-300" data-id="element-754"></span>}
          </li>)}
      </ul>
    </nav>;
};